import { useMutation, useQuery } from "@apollo/client";
import {
  Button,
  Center,
  ModalFooter,
  Spinner,
  useMediaQuery,
  useToast,
} from "@chakra-ui/react";
import { capitalize, get, isEmpty, omit, set } from "lodash";
import { compare } from "../../../../utils/helpers";

import ModalWrapper from "../../ModalWrapper";
import { UPDATE_COMMODITY } from "./mutations";
import { GET_COMMODITY } from "./queries";
import UpdateCommodityForm from "./UpdateCommodityForm";

type Props = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  id: string;
  retailOnly?: boolean;
  wholeSaleOnly?: boolean;
  refetch?: any;
  priceOnly?: boolean;
};

const UpdateCommodity = (props: Props) => {
  const { isOpen, onClose, id, retailOnly, wholeSaleOnly, refetch, priceOnly } =
    props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [updateCommodity, { loading: Updating }] =
    useMutation(UPDATE_COMMODITY);

  const toast = useToast();

  const { data, loading } = useQuery(GET_COMMODITY, {
    variables: {
      id,
      range: {},
    },
    fetchPolicy: "network-only",
  });

  const commodity = get(data, "commodity", {});

  const initialValues = {
    name: commodity.name,
    measurementUnit: commodity.measurementUnit,
    status: commodity.status,
    retail: data?.commodity?.retail,
    wholeSale: data?.commodity?.wholeSale,
    imageURL: commodity.imageURL,
  };

  const onSubmit = (values: any) => {
    const value = compare(
      initialValues,
      JSON.parse(JSON.stringify(omit(values, "isNewPrice")))
    );

    const isNewPrice = get(values, "isNewPrice");

    const { retail, wholeSale } = value;
    console.log("isNewPrice", isNewPrice);
    if (isNewPrice) {
      set(value, "isNewPrice", true);
    } else {
      set(value, "isNewPrice", false);
    }

    if (retail) {
      set(value, "retail", Number(retail));
    }

    if (wholeSale) {
      set(value, "wholeSale", Number(wholeSale));
    }

    set(value, "id", id);

    return updateCommodity({
      variables: {
        inputs: [
          {
            ...omit(value, ["note"]),
          },
        ],
      },
    })
      .then((data: any) => {
        if (data) {
          onClose();
          refetch && refetch();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: `${capitalize(data?.data.itemUpdate[0].name)} was updated`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
              position: !isLargerThan900 ? "bottom-left" : "bottom",
            });
          }
        }
      })
      .catch((error) => {
        if (!toast.isActive("active-toast")) {
          toast({
            id: "active-toast",
            title: error.message,
            description: "Please, try again.",
            status: "error",
            duration: 2000,
            isClosable: true,
            variant: "solid",
            position: !isLargerThan900 ? "bottom-left" : "bottom",
          });
        }
      });
  };

  const formName = "updateCommodityform";

  return (
    <ModalWrapper
      onClose={onClose}
      isOpen={isOpen}
      title={loading ? "" : `${capitalize(commodity.name)} | Update`}
    >
      {loading || Updating ? (
        <Center py="5">
          <Spinner />
        </Center>
      ) : (
        <UpdateCommodityForm
          onSubmit={onSubmit}
          formName={formName}
          retailOnly={retailOnly}
          wholeSaleOnly={wholeSaleOnly}
          priceOnly={priceOnly}
          initialValues={{
            ...initialValues,
            categories: data?.commodity?.categories,
          }}
        />
      )}
      <ModalFooter>
        <Button mr="3" w={isLargerThan900 ? "50" : "full"} onClick={onClose}>
          Cancel
        </Button>
        <Button
          w={isLargerThan900 ? "50" : "full"}
          form={formName}
          colorScheme="whatsapp"
          type="submit"
          isLoading={Updating}
          isDisabled={Updating}
        >
          Update
        </Button>
      </ModalFooter>
    </ModalWrapper>
  );
};

export default UpdateCommodity;
